import React from 'react';
import { AppBar, Toolbar, Typography, Box, Button, IconButton, Stack, Chip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';

export default function TopBar({ onToggleSidebar, showSidebarToggle }) {
  const navigate = useNavigate();
  const username = localStorage.getItem('username');
  const role = localStorage.getItem('role');
  const isDemo = localStorage.getItem('demo') === 'true';
  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };
  return (
    <AppBar position="fixed" sx={{ bgcolor: 'background.paper', color: 'text.primary', minHeight: 48, zIndex: (theme) => theme.zIndex.drawer + 2, borderBottom: '1px solid', borderColor: 'divider' }}>
      <Toolbar sx={{ minHeight: 48, display: 'flex', justifyContent: 'space-between', flexWrap: { xs: 'wrap', sm: 'nowrap' }, px: { xs: 1, sm: 2 } }}>
        <Box display="flex" alignItems="center" minWidth={0} flex={1}>
          {showSidebarToggle && (
            <IconButton color="inherit" edge="start" onClick={onToggleSidebar} sx={{ mr: 1, display: { xs: 'inline-flex', md: 'inline-flex' } }}>
              <MenuIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            color="inherit"
            fontWeight={700}
            noWrap
            sx={{
              flexShrink: 0,
              fontSize: { xs: 20, sm: 24 },
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: { xs: 120, sm: 200 },
            }}
          >
            ShopZo
          </Typography>
          {isDemo && (
            <Chip label="DEMO" color="warning" size="small" sx={{ ml: 1, fontWeight: 700 }} />
          )}
        </Box>
        {role && (
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 0, sm: 2 }}
            alignItems={{ xs: 'flex-end', sm: 'center' }}
            justifyContent="flex-end"
            sx={{ ml: { xs: 0, sm: 2 }, mt: { xs: 0.5, sm: 0 }, width: { xs: '100%', sm: 'auto' }, minWidth: 0 }}
          >
            <Typography
              variant="subtitle2"
              color="inherit"
              component="span"
              sx={{
                fontSize: { xs: 13, sm: 15 },
                maxWidth: { xs: 180, sm: 260 },
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block',
                textAlign: { xs: 'right', sm: 'left' },
              }}
              title={username ? `Logged in as: ${username}` : ''}
            >
              {username ? `Logged in as: ${username}` : ''} {role ? `(${role})` : ''}
            </Typography>
            <Button color="inherit" size="small" onClick={handleLogout} sx={{ fontSize: { xs: 13, sm: 15 }, minWidth: 64 }}>
              Logout
            </Button>
          </Stack>
        )}
      </Toolbar>
    </AppBar>
  );
} 
